export default __webpack_public_path__ + "static/media/1.0fa4dc15.jpg";